module.exports = __webpack_public_path__ + "privacy_policy.pdf";